import fetch from '@/assets/js/axios.js'
import { v4 as uuidv4 } from 'uuid'
// import { downloadFile } from '@/utils/downLoad'
// import { redirectUrl } from '@/utils'
import { DATA_SERVICE_API } from './apis'
function getQueryParams (params) {
  const queryParams = {
    id: uuidv4(),
    timestamp: Date.parse(new Date()),
    version: '1.0',
    params: params
  }
  console.log('queryParams:', JSON.stringify(queryParams))
  return queryParams
}

// 获取产品对应的统计任务列表
export function taskList (params) {
  return fetch({
    url: DATA_SERVICE_API.TASK_LIST,
    method: 'post',
    data: getQueryParams(params)
  })
}
// 获取对应统计任务数据
export function mapData (params) {
  return fetch({
    url: DATA_SERVICE_API.MAP,
    method: 'post',
    data: params
  })
}

// 获取对应统计任务数据
export function exportDataFile (params, successCalllback, failCallBack) {
  // downloadFile(DATA_SERVICE_API.DOWNLOAD_PATH, getQueryParams(params), successCalllback, failCallBack)
  return fetch({
    url: DATA_SERVICE_API.DOWNLOAD_PATH,
    method: 'post',
    data: {
      params: params
    }
  })
}

// 任务管理任务列表
export function taskTaskList (params) {
  return fetch({
    url: DATA_SERVICE_API.TASK_TASKLIST,
    method: 'post',
    data: params
  })
}

// 任务修改
export function editTask (params) {
  return fetch({
    url: DATA_SERVICE_API.EDIT_TASK,
    method: 'post',
    data: params
  })
}

// 任务添加
export function addTask (params) {
  return fetch({
    url: DATA_SERVICE_API.ADD_TASK,
    method: 'post',
    data: params
  })
}

// 任务添加
export function homeMap () {
  return fetch({
    url: DATA_SERVICE_API.HOME_MAP,
    method: 'post',
    data: {}
  })
}

// 任务删除
export function delTask (params) {
  return fetch({
    url: DATA_SERVICE_API.DEL_TASK,
    method: 'post',
    data: {
      params
    }
  })
}

// 任务得开启关闭
export function taskStatus (params) {
  return fetch({
    url: DATA_SERVICE_API.TASK_STATUS,
    method: 'post',
    data: {
      params
    }
  })
}

// 任务详情
export function taskDetail (params) {
  return fetch({
    url: DATA_SERVICE_API.TASK_DETAIL,
    method: 'post',
    data: {
      params
    }
  })
}

// 手动触发任务
export function taskTimerManual (params) {
  return fetch({
    url: DATA_SERVICE_API.TASK_TIMER_MANUAL,
    method: 'post',
    data: {
      params
    }
  })
}

// 手动触发任务之前进行检查
export function timerCheck (params) {
  return fetch({
    url: DATA_SERVICE_API.TIMER_CHECK,
    method: 'post',
    data: {
      params
    }
  })
}

// 存在统计任务的产品信息
export function taskProductInfo () {
  return fetch({
    url: DATA_SERVICE_API.TASK_PRODUCT_INFO,
    method: 'post',
    data: { params: {} }
  })
}

// 任务名称模糊查询
export function taskName (params) {
  return fetch({
    url: DATA_SERVICE_API.TASK_NAME,
    method: 'post',
    data: { params }
  })
}
